import React from 'react'
import PropTypes from 'prop-types'
import { View, StyleSheet } from '@react-pdf/renderer'
import colors from '@settings/styleSettings'

// Create styles
const styles = StyleSheet.create({
  line: {
    borderTopWidth: 1,
    width: '100%',
  },
})

// Create Document Component
export const Line = ({ lineColor, style }) => (
  <View style={[styles.line, { borderColor: lineColor }, style]} />
)

Line.propTypes = {
  lineColor: PropTypes.string,
  style: PropTypes.shape({}),
}

Line.defaultProps = {
  lineColor: colors.softGray,
  style: null,
}
